module.exports = __webpack_public_path__ + "img/5502e81.png";